import { useEffect, useEffectEvent } from "react";
import { Button } from "./Button";
import { ShortcutHint } from "./ShortcutHint";
import { Tooltip } from "./Tooltip";

type Props = {
  onClick: () => void;
  disabled?: boolean;
  disabledReason?: string;
};

export function VoiceModeButton({ onClick, disabled, disabledReason }: Props) {
  const start = useEffectEvent(onClick);

  useEffect(() => {
    if (disabled) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        !e.defaultPrevented &&
        !e.repeat &&
        !e.isComposing &&
        e.shiftKey &&
        e.altKey &&
        !e.metaKey &&
        !e.ctrlKey &&
        e.code === "KeyV"
      ) {
        e.preventDefault();
        start();
      }
    };
    document.addEventListener("keydown", handleKeyDown, { capture: true });
    return () =>
      document.removeEventListener("keydown", handleKeyDown, { capture: true });
  }, [disabled]);

  return (
    <Tooltip
      content={
        disabled && disabledReason ? (
          disabledReason
        ) : (
          <>
            Voice mode <ShortcutHint>⇧⌥V</ShortcutHint>
          </>
        )
      }
    >
      <Button
        type="button"
        icon="mic"
        variant="secondary"
        aria-label="Voice mode"
        aria-keyshortcuts="Alt+Shift+V"
        disabled={disabled}
        onMouseDown={(e) => e.preventDefault()}
        onClick={onClick}
      />
    </Tooltip>
  );
}
